import { HeaderWithBackButtonDefault } from '@UI/New/HeaderWithBackButton'
import PageWrapper from '@UI/New/PageWrapper'
import { CSSProperties, FC, ReactNode } from 'react'
import cn from './index.module.css'
import classNames from 'classnames'

interface IReportWrapper {
  headerClassName?: string
  pageClassName?: string
  hideHeader?: boolean
  children: ReactNode
}

const ReportWrapper: FC<IReportWrapper> = ({
  children,
  headerClassName,
  pageClassName,
  hideHeader = false,
}) => {
  return (
    <>
      <HeaderWithBackButtonDefault
        className={classNames(cn.pageHeader, headerClassName, {
          [cn.hideHeader]: hideHeader,
        })}
      />
      <PageWrapper
        className={classNames(cn.pageWrapper, pageClassName, {
          [cn.embeddedPageWrapper]: hideHeader,
        })}
      >
        {children}
      </PageWrapper>
    </>
  )
}

export default ReportWrapper
